<template>
  <div class="quota-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary" @click="openFilter">
            <a-icon type="filter" /> 高级筛选
          </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button>
        </template>

        <template slot="blCustName" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.blCustName }}
          </div>
        </template>
        <template slot="quotaStatus" slot-scope="{ row }">
          <div class="quota-status" v-if="row.status == 1">生效</div>
          <div class="quota-status red-point" v-else>失效</div>
        </template>
      </avue-crud>
    </div>

    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="60%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <div class="drawer_screen_wrapper">
        <div class="screen_header">
          <div class="screen_header_name">
            <a-icon type="filter" />
            高级筛选
          </div>
          <div class="screen_header_remarks" @click="drawer = false">
            <i class="el-icon-video-play"></i>
            收起
          </div>
        </div>
        <div class="screen_content">
          <avue-form
            :option="filterConfig"
            ref="formScreen"
            v-model="searchForm"
            @submit="filterSearch"
            @reset-change="searchResetScreen"
          >
            <template slot="factoringCredit">
              <div class="form_slot">
                <el-input-number
                  v-model="searchForm.factoringCreditMin"
                  :controls="false"
                  placeholder="开始数值"
                  style="width: 100%"
                />
                &nbsp;~&nbsp;
                <el-input-number
                  v-model="searchForm.factoringCreditMin"
                  :controls="false"
                  placeholder="结束数值"
                  style="width: 100%"
                />
              </div>
            </template>
          </avue-form>
        </div>
      </div>
    </el-drawer>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import commonList from "@/mixins/list";
import { quotaListConfig, filterConfig } from "./quotaConfig.js";
import { getQuotaList } from "@/api/factoring/factoringQuota";
import { downLoadTemplateGet } from "@/router/downLoadTem";
import { mapGetters } from "vuex";
export default {
  name: "QuotaList",
  mixins: [commonList],
  data() {
    return {
      drawer: false,
      tableData: [],
      searchForm: {},
      checkUserList: [],
      checkdepartment: [],
      tableConfig: quotaListConfig(
        this.getMoney,
        this.selectPersonClick,
        this.selectDeptClick
      ),
      filterConfig: filterConfig(this.selectPersonClick, this.selectDeptClick),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
  },
  mounted() {
    let setParams = {
      departmentIDKey: "managerDept",
    };
    this.setCommonParams(setParams);
    // 设置导出链接
    // this.setExportUrl("/api/bl/blquota/export");
  },
  methods: {
    cloudTages(data) {
      this.searchForm = data;
    },
    save(row) {
      this.$refs.cloudtage.save(row);
    },
    goDetail(row) {
      if(!this.permission.factoringQuotaList_view){
        this.$message.error("没有查看权限");
        return
      }

      this.$router.push({
        path: `/factoring/quotaManage/quotaDetail/${row.blCustId}`,
      });
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        isGroup: "1",
        ...this.searchForm,
      };
      let res = await getQuotaList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
        auditState: 1,
        isGroup: "1",
      };
      if (value.code == 1) {
        data = {
          ...data,
          current: page.currentPage,
          size: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplateGet("/api/bl/blquota/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.quota-list-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
}
</style>